import { Component, ComponentChild } from 'preact'
import { arrayMove, SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc'

/* eslint-disable import/no-internal-modules */
import Union from '@insided/deprecated-control/category/assets/Union'
import InputGroup from '@insided/deprecated-control/ui-components/InputGroup'
import InputGroupWithIcons from '@insided/deprecated-control/ui-components/InputGroupWithIcons'
import { t } from '@insided/deprecated-libs/translationsUtils/translations'
import Icon from '@insided/deprecated-preact-components/assets'

export interface PollType {
  question: string
  options: string[]
}

interface OnItemsSorted {
  oldIndex: number
  newIndex: number
}

interface Props {
  options: string[]
  question: string
  onChange: (data: Pick<PollType, 'question'> | Pick<PollType, 'options'>) => void
  onDelete: () => void
}

interface State {
  newOption: string
}

const DragHandle = SortableHandle(() => (
  <span className='drag-handle'>
    <Union />
  </span>
))

const SortableList = SortableContainer(({ children }: { children: ComponentChild }) => children)
const SortableItem = SortableElement(({ children }: { children: ComponentChild }) => children)

class Poll extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      newOption: ''
    }

    this.addNewItemToList = this.addNewItemToList.bind(this)
    this.updateItemInList = this.updateItemInList.bind(this)
    this.deleteItemFromList = this.deleteItemFromList.bind(this)
    this.onItemsSorted = this.onItemsSorted.bind(this)
  }

  addNewItemToList() {
    this.props.onChange({ options: this.props.options.concat([this.state.newOption]) })
    this.setState({ newOption: '' })
  }

  deleteItemFromList(idx: number) {
    const newList = this.props.options
    newList.splice(idx, 1)
    this.props.onChange({ options: newList })
  }

  updateItemInList(newValue: string, idx: number) {
    this.props.options[idx] = newValue
    this.props.onChange({ options: this.props.options })
  }

  onItemsSorted({ oldIndex, newIndex }: OnItemsSorted) {
    this.props.onChange({ options: arrayMove(this.props.options, oldIndex, newIndex) })
  }

  render() {
    const { question, options, onChange, onDelete } = this.props
    const { newOption } = this.state
    return (
      <div className='poll-wrapper'>
        <div className='poll-question'>
          <InputGroup
            title={t('Forum', 'topic.editor.poll.question.title')}
            placeholder={t('Control', 'poll.placeholder.question')}
            type='text'
            qaClasses='qa-poll-question'
            onChange={(e) => onChange({ question: e.target.value })}
            value={question}
          />
        </div>

        <div className='poll-options'>
          <strong>{t('Forum', 'topic.editor.poll.answers.title')}</strong>

          <SortableList useDragHandle onSortEnd={this.onItemsSorted}>
            <div>
              {options.map((item, idx) => (
                <SortableItem index={idx} key={idx}>
                  <InputGroupWithIcons
                    attributes={{
                      type: 'text',
                      value: item
                    }}
                    className='qa-poll-option'
                    preIcon={<DragHandle />}
                    postIcon={<Icon onClick={() => this.deleteItemFromList(idx)} icon='close' />}
                    onChange={(newValue: string) => this.updateItemInList(newValue, idx)}
                  />
                </SortableItem>
              ))}
            </div>
          </SortableList>

          <InputGroupWithIcons
            attributes={{
              type: 'text',
              value: newOption,
              placeholder: t('Forum', 'topic.editor.poll.answers.placeholder')
            }}
            className='qa-poll-add'
            preIcon={<Icon onClick={this.addNewItemToList} icon='add' />}
            onEnter={this.addNewItemToList}
            onChange={(newValue: string) => this.setState({ newOption: newValue })}
          />
        </div>

        <div className='poll-delete'>
          <span className='poll-delete-link' onClick={onDelete}>
            {t('Forum', 'Remove poll')}
          </span>
        </div>
      </div>
    )
  }
}

export default Poll
